export default __webpack_public_path__ + "img/ill_header2.51a7916e.png";